function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { message, Descriptions, Tabs, Skeleton, List, Button, Modal, DatePicker, notification, Space, Form } from "antd";
import NewAppointment from "./forms/NewAppointment";
import Calendar from 'react-calendar';
import Common from "./includes/Common";
import { PhoneFill, PersonFill, PencilSquare, CalendarEventFill, TrashFill, PersonLock, ListCheck, ArrowClockwise } from 'react-bootstrap-icons';
import Moment from "react-moment";
import moment from "moment";
import dayjs from "dayjs";
import EditCustomer from "./forms/EditCustomer";
import EditAppointment from "./forms/EditAppointment";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
var RangePicker = DatePicker.RangePicker;
var Appointment = function Appointment() {
  var _Modal$useModal = Modal.useModal(),
    _Modal$useModal2 = _slicedToArray(_Modal$useModal, 2),
    confirm = _Modal$useModal2[0].confirm,
    contextHolder = _Modal$useModal2[1];
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    appointments = _useState2[0],
    setAppiontments = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isDataLoading = _useState4[0],
    setIsDataLoading = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    dataChanged = _useState6[0],
    setDataChanged = _useState6[1];
  var _useState7 = useState(""),
    _useState8 = _slicedToArray(_useState7, 2),
    selectedId = _useState8[0],
    setSelectedId = _useState8[1];
  var _useState9 = useState(false),
    _useState0 = _slicedToArray(_useState9, 2),
    isUpcomingLoading = _useState0[0],
    setIsUpcomingLoading = _useState0[1];
  var _useState1 = useState(false),
    _useState10 = _slicedToArray(_useState1, 2),
    showEditAppointment = _useState10[0],
    setShowEditAppointment = _useState10[1];
  var _useState11 = useState(null),
    _useState12 = _slicedToArray(_useState11, 2),
    currentCustomer = _useState12[0],
    setCurrenCustomer = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    monthlyAppointments = _useState14[0],
    setMonthlyAppointments = _useState14[1];
  var _useState15 = useState([]),
    _useState16 = _slicedToArray(_useState15, 2),
    upcommingAppointments = _useState16[0],
    setUpcommingAppointments = _useState16[1];
  var _useState17 = useState([]),
    _useState18 = _slicedToArray(_useState17, 2),
    monthlyAppointmentsDate = _useState18[0],
    setMonthlyAppointmentsDate = _useState18[1];
  var _useState19 = useState([]),
    _useState20 = _slicedToArray(_useState19, 2),
    upcomingAppointmentsDate = _useState20[0],
    setUpcomingAppointmentsDate = _useState20[1];
  var _useState21 = useState(false),
    _useState22 = _slicedToArray(_useState21, 2),
    showAdd = _useState22[0],
    setShowAdd = _useState22[1];
  var _useState23 = useState(false),
    _useState24 = _slicedToArray(_useState23, 2),
    isPatientsLoading = _useState24[0],
    setIsPatientsLoading = _useState24[1];
  var _useState25 = useState(false),
    _useState26 = _slicedToArray(_useState25, 2),
    showEdit = _useState26[0],
    setShowEdit = _useState26[1];
  var _useState27 = useState(null),
    _useState28 = _slicedToArray(_useState27, 2),
    selectedAp = _useState28[0],
    setSelectedAp = _useState28[1];
  var _useState29 = useState([]),
    _useState30 = _slicedToArray(_useState29, 2),
    createdCustomers = _useState30[0],
    setCreatedCustomers = _useState30[1];
  var _useState31 = useState(dayjs().startOf("week")),
    _useState32 = _slicedToArray(_useState31, 2),
    from = _useState32[0],
    setFrom = _useState32[1];
  var _useState33 = useState(dayjs().endOf("week")),
    _useState34 = _slicedToArray(_useState33, 2),
    to = _useState34[0],
    setTo = _useState34[1];
  var _useState35 = useState(dayjs().startOf("month")),
    _useState36 = _slicedToArray(_useState35, 2),
    apFrom = _useState36[0],
    setApFrom = _useState36[1];
  var _useState37 = useState(dayjs().endOf("month")),
    _useState38 = _slicedToArray(_useState37, 2),
    apTo = _useState38[0],
    setApTo = _useState38[1];
  useEffect(function () {
    setIsDataLoading(true);
    setDataChanged(false);
    axios.get(Common.baseApiUrl + "getappointments/" + apFrom.format() + "/" + apTo.format() + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setUpcomingAppointmentsDate([]);
        setAppiontments([]);
        setAppiontments(response.data.appointments);
        response.data.appointments.forEach(function (e) {
          setUpcomingAppointmentsDate(function (prev) {
            return [].concat(_toConsumableArray(prev), [moment(e.date).format("DD-MM-YYYY")]);
          });
        });
      } else {
        message.error({
          content: response.data.message,
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsDataLoading(false);
    });
  }, [dataChanged, apFrom, apTo]);
  useEffect(function () {
    setIsPatientsLoading(true);
    axios.get(Common.baseApiUrl + "getusercreatedpatients/" + from.format() + "/" + to.format() + "/" + Common.currentUser.id).then(function (response) {
      if (response.data.status == 200) {
        setCreatedCustomers(response.data.customers);
      } else {
        message.error({
          content: response.data.message,
          delay: 4
        });
      }
    })["catch"](function (error) {
      message.error({
        content: "Une erreur est survenue",
        delay: 4
      });
    })["finally"](function () {
      setIsPatientsLoading(false);
    });
  }, [dataChanged]);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx("div", {
      className: "white-bg",
      style: {
        minHeight: "650px"
      },
      children: /*#__PURE__*/_jsx(Container, {
        children: /*#__PURE__*/_jsxs(Row, {
          children: [/*#__PURE__*/_jsx(Col, {
            lg: 7,
            md: 8,
            children: /*#__PURE__*/_jsx(Tabs, {
              animated: true,
              items: [{
                key: 1,
                label: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(ListCheck, {}), " Liste"]
                }),
                children: /*#__PURE__*/_jsxs(_Fragment, {
                  children: [/*#__PURE__*/_jsx(Form, {
                    onFinish: function onFinish(values) {
                      setApFrom(moment(values.period[0].$d).format());
                      setApTo(moment(values.period[1].$d).format());
                    },
                    layout: "vertical",
                    children: /*#__PURE__*/_jsxs(Space, {
                      direction: "horizontal",
                      children: [/*#__PURE__*/_jsx(Form.Item, {
                        name: "period",
                        rules: [{
                          required: true,
                          message: "Choisir une date de depart"
                        }],
                        children: /*#__PURE__*/_jsx(RangePicker, {
                          needConfirm: false,
                          format: "DD/MM/YYYY"
                        })
                      }), /*#__PURE__*/_jsxs(Space, {
                        direction: "horizontal",
                        children: [/*#__PURE__*/_jsx(Form.Item, {
                          children: /*#__PURE__*/_jsx(Button, {
                            type: "primary",
                            htmlType: "submit",
                            children: /*#__PURE__*/_jsx("b", {
                              children: "Filtrer"
                            })
                          })
                        }), /*#__PURE__*/_jsx(Form.Item, {
                          children: /*#__PURE__*/_jsx(Button, {
                            loading: isUpcomingLoading,
                            type: "link",
                            onClick: function onClick() {
                              setApFrom(dayjs().startOf("month"));
                              setApTo(dayjs().endOf("month"));
                            },
                            icon: /*#__PURE__*/_jsx(ArrowClockwise, {
                              size: 24
                            }),
                            children: "Rdv \xE0 venir"
                          })
                        })]
                      })]
                    })
                  }), /*#__PURE__*/_jsx("br", {}), appointments.map(function (a) {
                    return /*#__PURE__*/_jsxs(Descriptions, {
                      style: {
                        marginBottom: '10px'
                      },
                      size: "small",
                      bordered: true,
                      column: 1,
                      children: [/*#__PURE__*/_jsx(Descriptions.Item, {
                        label: /*#__PURE__*/_jsx("b", {
                          children: "Rdv Patient"
                        }),
                        children: /*#__PURE__*/_jsxs(Space, {
                          direction: "horizontal",
                          children: [/*#__PURE__*/_jsxs("div", {
                            children: [a.customer.firstname + " " + a.customer.lastname + " (" + a.customer.idnumber + ") ", /*#__PURE__*/_jsxs("span", {
                              style: {
                                color: "#996444",
                                fontWeight: "bold"
                              },
                              children: ["- Le ", /*#__PURE__*/_jsx(Moment, {
                                locale: "Fr",
                                format: "DD/MM/YYYY hh:mm",
                                children: a.date
                              })]
                            })]
                          }), /*#__PURE__*/_jsx(Button, {
                            type: "default",
                            onClick: function onClick() {
                              setSelectedAp(a);
                              setShowEditAppointment(true);
                            },
                            children: /*#__PURE__*/_jsx(PencilSquare, {
                              size: 17
                            })
                          }), contextHolder, /*#__PURE__*/_jsx(Button, {
                            type: "default",
                            onClick: function onClick() {
                              confirm({
                                title: /*#__PURE__*/_jsx("b", {
                                  children: "Confirmez - vous ? "
                                }),
                                content: /*#__PURE__*/_jsxs("p", {
                                  children: ["La suppression du rendez-vous pour le patient ", a.customer.firstname + " " + a.customer.lastname, " ?"]
                                }),
                                onOk: function onOk() {
                                  axios.get(Common.baseApiUrl + "deleteappointment/" + a.id + "/" + Common.currentUser.id).then(function (response) {
                                    if (response.data.status == 200) {
                                      notification.success(_defineProperty({
                                        message: "Ok!"
                                      }, "message", response.data.message));
                                      setDataChanged(true);
                                    } else {
                                      notification.error(_defineProperty({
                                        message: "Oops!"
                                      }, "message", response.data.message));
                                    }
                                  })["catch"](function (error) {
                                    notification.error(_defineProperty({
                                      message: "Oops!"
                                    }, "message", "Une erreur est survenue"));
                                  })["finally"](function () {});
                                }
                              });
                            },
                            children: /*#__PURE__*/_jsx(TrashFill, {
                              size: 17
                            })
                          })]
                        })
                      }), /*#__PURE__*/_jsx(Descriptions.Item, {
                        label: "Raison",
                        children: a.reason
                      }), /*#__PURE__*/_jsx(Descriptions.Item, {
                        label: /*#__PURE__*/_jsx(PhoneFill, {
                          size: 20
                        }),
                        children: /*#__PURE__*/_jsx("b", {
                          children: a.customer.mobile.toString().slice(3)
                        })
                      })]
                    }, a.id);
                  }), isDataLoading && appointments.length == 0 && /*#__PURE__*/_jsx("div", {
                    children: "Vous n'avez aucun rendez-vous"
                  })]
                })
              }, {
                key: 2,
                label: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(CalendarEventFill, {}), " Calendrier"]
                }),
                children: /*#__PURE__*/_jsx(_Fragment, {
                  children: /*#__PURE__*/_jsx(Calendar, {
                    style: {
                      height: 900,
                      width: "100%"
                    },
                    onChange: null,
                    locale: "fr-FR",
                    value: null,
                    tileClassName: function tileClassName(_ref) {
                      var date = _ref.date,
                        view = _ref.view;
                      if (monthlyAppointmentsDate.find(function (x) {
                        return x === moment(date).format("DD-MM-YYYY");
                      }) || upcomingAppointmentsDate.find(function (x) {
                        return x === moment(date).format("DD-MM-YYYY");
                      })) {
                        return 'highlight';
                      } else {
                        return 'reg_calendar_item';
                      }
                    },
                    tileDisabled: function tileDisabled(_ref2) {
                      var date = _ref2.date;
                      return date.getDay() === 0;
                    }
                  })
                })
              }, {
                key: 3,
                label: /*#__PURE__*/_jsxs("b", {
                  children: [/*#__PURE__*/_jsx(PersonLock, {}), " Mes dossiers cr\xE9\xE9s"]
                }),
                children: /*#__PURE__*/_jsx(_Fragment, {
                  children: createdCustomers.length > 0 && /*#__PURE__*/_jsx(List, {
                    className: "demo-loadmore-list",
                    loading: isPatientsLoading,
                    itemLayout: "horizontal",
                    dataSource: createdCustomers,
                    renderItem: function renderItem(item) {
                      return /*#__PURE__*/_jsx(List.Item, {
                        actions: [/*#__PURE__*/_jsx(Button, {
                          icon: /*#__PURE__*/_jsx(PencilSquare, {}),
                          type: "link",
                          onClick: function onClick() {
                            setCurrenCustomer(item);
                            setShowEdit(true);
                          },
                          children: "Modifier"
                        }, "list-loadmore-edit"), /*#__PURE__*/_jsx(Button, {
                          icon: /*#__PURE__*/_jsx(CalendarEventFill, {}),
                          type: "link",
                          onClick: function onClick() {
                            setSelectedId(item.idnumber);
                          },
                          children: "Rendez-vous"
                        }, "list-loadmore-more")],
                        children: /*#__PURE__*/_jsxs(Skeleton, {
                          avatar: true,
                          title: false,
                          loading: isPatientsLoading,
                          active: true,
                          children: [/*#__PURE__*/_jsx(List.Item.Meta, {
                            avatar: /*#__PURE__*/_jsx(PersonFill, {}),
                            title: /*#__PURE__*/_jsx("b", {
                              children: item.firstname + " " + item.lastname
                            }),
                            description: "Code Patient: " + item.idnumber
                          }), /*#__PURE__*/_jsx("div", {})]
                        })
                      });
                    }
                  })
                })
              }]
            })
          }), /*#__PURE__*/_jsx(Col, {
            lg: 5,
            md: 4,
            children: /*#__PURE__*/_jsx("div", {
              style: {
                borderRadius: "8px",
                background: "#FED087",
                padding: "15px"
              },
              children: /*#__PURE__*/_jsx(NewAppointment, {
                customerId: selectedId,
                handler: function handler() {
                  setDataChanged(true);
                }
              })
            })
          })]
        })
      })
    }), currentCustomer && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "Modifier le dossier"
        }),
        width: {
          xs: '95%',
          sm: '80%',
          md: '70%',
          lg: '60%',
          xl: '50%',
          xxl: '50%'
        },
        open: showEdit,
        onCancel: function onCancel() {
          setShowEdit(false);
        },
        footer: null,
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(EditCustomer, {
          customer: currentCustomer,
          handleUpdate: function handleUpdate() {
            setShowEdit(false);
            notification.success({
              message: "Ok!",
              description: "Le dossier a été modifié"
            });
          }
        })
      })
    }), selectedAp && /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx(Modal, {
        title: /*#__PURE__*/_jsx("b", {
          children: "Modifier un rendez-vous"
        }),
        width: {
          xs: '95%',
          sm: '80%',
          md: '40%',
          lg: '40%',
          xl: '30%',
          xxl: '30%'
        },
        open: showEditAppointment,
        onCancel: function onCancel() {
          setShowEditAppointment(false);
        },
        footer: null,
        destroyOnClose: true,
        children: /*#__PURE__*/_jsx(EditAppointment, {
          appointment: selectedAp,
          handler: function handler() {
            setShowEditAppointment(false);
            setDataChanged(true);
            notification.success({
              message: "Ok!",
              description: "Le rdv a été modifié"
            });
          }
        })
      })
    })]
  });
};
export default Appointment;